<div appDialogSelectable appDialogKeyboardEnabled>
  <div
    class="atlas-info-dialog"
    (cdkDragStarted)="dialogBoundryService.handleDragStart($event)"
    (cdkDragEnded)="dialogBoundryService.handleDragEnd($event)"
    cdkDragRootElement=".cdk-overlay-pane"
    cdkDrag
  >
    <div appDialogDragArea cdkDragHandle></div>
    <div class="modal-content">
      <div class="modal-header">
        <div class="modal-header-title">About Atlas</div>
        <div class="modal-buttons">
          <div (click)="close()">
            <img src="/assets/icons/Close White.svg" alt="Close" />
          </div>
        </div>
      </div>

      <div class="modal-content-body atlas-info-dialog-body">
        <div class="info-shell">
          <div class="info-hero">
            <div class="info-logo" aria-hidden="true"></div>
            <div class="info-copy">
              <div class="info-title">Atlas</div>
              <div class="info-subtitle">AI enabled support inside the SECCA workspace</div>
            </div>
          </div>

          <div class="info-grid">
            <div class="info-card">
              <div class="info-card-head">
                <div class="info-card-icon info-card-icon-chat" aria-hidden="true"></div>
                <div class="info-card-title">Chat</div>
              </div>
              <div class="info-card-text">
                Ask Atlas questions in natural language. The chat can answer with or without enabled case context and can use suggested prompts as a starting point.
              </div>
            </div>

            <div class="info-card">
              <div class="info-card-head">
                <div class="info-card-icon info-card-icon-case-context" aria-hidden="true"></div>
                <div class="info-card-title">Case Context</div>
              </div>
              <div class="info-card-text">
                Case Context controls which active case fields Atlas may include when answering. The context can include information such as product,
                incident details, diagnosis, travel dates, reporter, co-travellers, and selected insurance data.
              </div>
            </div>

            <div class="info-card">
              <div class="info-card-head">
                <div class="info-card-icon info-card-icon-context-switch" aria-hidden="true">
                  <div class="info-context-switch">
                    <span class="info-context-switch-track">
                      <span class="info-context-switch-thumb"></span>
                    </span>
                    <span class="info-context-switch-labels">
                      <span class="info-context-switch-text info-context-switch-text-off">Off</span>
                      <span class="info-context-switch-text info-context-switch-text-on">On</span>
                    </span>
                  </div>
                </div>
                <div class="info-card-title">Case Context Chat mode</div>
              </div>
              <div class="info-card-text">
                When enabled, Atlas can use selected case fields to narrow answers to the active case.
              </div>
            </div>

            <div class="info-card">
              <div class="info-card-head">
                <div class="info-card-icon info-card-icon-chat-history" aria-hidden="true"></div>
                <div class="info-card-title">Chat History</div>
              </div>
              <div class="info-card-text">
                Chat History keeps saved Atlas chats, messages, scores, and feedback so previous conversations can be reopened and reviewed.
              </div>
            </div>

            <div class="info-card">
              <div class="info-card-head">
                <div class="info-card-icon info-card-icon-template" aria-hidden="true"></div>
                <div class="info-card-title">Template support</div>
              </div>
              <div class="info-card-text">
                The first contact template view can retrieve template questions and fill out answers based on case data.
              </div>
            </div>

            <!--
            <div class="info-card">
              <div class="info-card-head">
                <div class="info-card-icon info-card-icon-validation" aria-hidden="true"></div>
                <div class="info-card-title">Case validation</div>
              </div>
              <div class="info-card-text">
                The case validation view checks travel insurance is compliant with travel details and will try to identify potential
                rules within the policy that will be relevant.
              </div>
            </div>
            -->

            <!-- Trigger disabled: (click)="openFraudDetectionRulesDialog()" -->
            <div class="info-card">
              <div class="info-card-head">
                <div class="info-card-icon info-card-icon-fraud" aria-hidden="true"></div>
                <div class="info-card-title">Fraud Detection</div>
              </div>
              <div class="info-card-text">
                The fraud detection view scores the active case using diagnosis, country, travel dates, and treatment service order details.
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
